import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-call-us',
    templateUrl: './call-us.component.html',
    styleUrls: ['./call-us.component.scss'],
})
export class CallUsComponent {
    name: string;
    phone: string;
    policy: boolean;

    constructor(
        private http: HttpClient,
        private toastr: ToastrService,
        private router: Router,
        private translate: TranslateService
    ) {}

    onSubmit() {
        if (!this.policy) {
            this.toastr.error(
                this.translate.instant('form_error_fill_all_fields')
            );
            return;
        }

        this.http
            .post('/api/contact/', {
                name: this.name,
                phone: this.phone,
                policy: this.policy,
            })
            .subscribe(
                () => {
                    this.router.navigate(['/dziekujemy']);
                    this.name = null;
                    this.phone = null;
                },
                () => {
                    this.toastr.error(
                        this.translate.instant('form_error_invalid')
                    );
                }
            );
    }
}
